/**
 * Вычисляет необходимое количество комнат для размещения гостей
 * @param guestsCount - Общее количество гостей
 * @param maxGuestsPerRoom - Максимальное количество гостей в одной комнате
 * @returns Количество необходимых комнат
 */
export const calculateRoomsCount = (
  guestsCount: number,
  maxGuestsPerRoom: number,
): number => {
  if (guestsCount <= 0 || maxGuestsPerRoom <= 0) {
    return 0
  }

  return Math.ceil(guestsCount / maxGuestsPerRoom)
}
